import React from 'react';
import cn from 'classnames';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import A11y from 'chameleon/ui-stack/utilities/a11y';

const ListItem = React.forwardRef(
  (
    { item, matchingValue, highlightedIndex, index, getItemProps, ...props },
    ref,
  ) => (
    <A11y>
      <li
        data-test-id="autocomplete-list-item"
        {...getItemProps({ item })}
        className={cn(
          'autocomplete__dropdown-item text-gray-900 text-15 border-b',
          'border-gray-400 cursor-pointer flex items-center justify-between w-full',
          'whitespace-nowrap',
          {
            'bg-blue-100': matchingValue,
            'bg-gray-200': highlightedIndex === index,
            'text-gray-600 italic cursor-not-allowed pointer-events-none':
              item.disabled,
          },
        )}
        {...props}
        role="option"
        aria-selected={matchingValue}
        ref={ref}
      >
        {item.subLabel ? (
          <div>
            <div className="pb-3">
              <strong>{item.label}</strong>
            </div>
            <div>
              <span className="text-gray-600">{item.subLabel}</span>
            </div>
          </div>
        ) : (
          item.label
        )}
        {matchingValue && (
          <Icon
            className="autocomplete__dropdown-item-icon ml-4"
            width={16}
            height={16}
            name="checkmark"
            accessibility={{
              ariaHidden: true,
            }}
          />
        )}
      </li>
    </A11y>
  ),
);

export default ListItem;
